<script>
export default {
  head() {
    return {
      link: [
        {
          rel: 'icon',
          href: `${this.$store.state.company.company.logoOssUrl}`
        }
      ],
      script: [{ src: '/script/statistic.js' }]
    }
  }
}
</script>
<template>
  <div>
    <nuxt />
  </div>
</template>

<style lang="scss">
html {
  font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}

.app_header {
  height: 70px;
  font-size: 20px;
  border-bottom: 1px solid rgba(192, 204, 218, 1);
  margin-bottom: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    margin-left: 10px;
  }
}

@media screen and (max-width: 940px) {
  .app_header {
    height: 56px;
    border-bottom: none;
    margin-bottom: 0;
  }
}
</style>
